<template>
  <div class="col-12">
    <div><h3>{{course.title}}</h3></div>
    <div><b>{{'Number of invites left' | translate}}:</b> {{ licencesLeft }}</div>
    <div><small>{{'If you want to participate - please add your email address below' | translate}}</small></div>

    <div class="my-5">
      <table class="table">
        <thead>
          <tr>
            <th class="border-0">{{'Name' | translate}}</th>
            <th class="border-0">Email</th>
            <th class="border-0">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="invitation in invitations" :key="invitation.id">
            <td>{{ invitation.name }}</td>
            <td>{{ invitation.email }}</td>
            <td class="d-flex justify-content-between">
              <div>
                {{invitation.status | translate}}
              </div>
              <div
                v-if="invitation.status === 'sent'"
                @click="openModal(invitation)"
              >
                <button class="btn btn-outline-danger btn-sm">X</button>
              </div>
            </td>
          </tr>
          <tr v-if="licencesLeft">
            <td>
              <input
                type="text"
                class="form-control"
                :placeholder="$t('Name')"
                v-model="name"
              />
            </td>
            <td>
              <input
                type="text"
                class="form-control"
                placeholder="Email"
                v-model="email"
              />
            </td>
            <td class="text-center">
              <button class="btn btn-outline-primary" @click="create">
                {{'Invite' | translate}}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Bootstrap Modal for Delete Confirmation -->
    <div ref="modal" class="modal fade" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('Are you sure?') }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>{{ $t('Do you realy want to delete this invitation?') }}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="hideModal">{{ $t('Cancel') }}</button>
            <button type="button" class="btn btn-danger" @click="confirmDelete">{{ $t('Delete') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['course', 'transaction'],
  data() {
    return {
      invitations: this.transaction.child_invitations,
      name: '',
      email: '',
      modalInstance: null,
      invitationToDelete: null,
    }
  },
  mounted() {
    // Assumes Bootstrap 5 JS is loaded globally
    this.modalInstance = new window.bootstrap.Modal(this.$refs.modal, {
      backdrop: 'static',
      keyboard: false,
    })
  },
  methods: {
    openModal(invitation) {
      this.invitationToDelete = invitation
      this.modalInstance.show()
    },
    hideModal() {
      this.invitationToDelete = null
      this.modalInstance.hide()
    },
    confirmDelete() {
      if (!this.invitationToDelete) return
      axios
        .delete(`/home/access-manager/${this.course.id}/${this.invitationToDelete.id}`)
        .then(({ data }) => {
          this.invitations = this.invitations.filter(
            (invite) => invite.id !== this.invitationToDelete.id
          )
          this.hideModal()
        })
        .catch(() => {
          this.hideModal()
        })
    },
    create() {
      axios
        .post(`/home/access-manager/${this.course.id}`, {
          course_id: this.course.id,
          parent_transaction_id: this.transaction.id,
          name: this.name,
          email: this.email,
        })
        .then(({ data }) => {
          this.email = ''
          this.name = ''
          this.invitations.push(data)
        })
    },
  },
  computed: {
    licencesLeft() {
      let left = this.transaction.quantity - this.invitations.length
      if (left > 0) {
        return left
      }
      return 0
    },
  },
}
</script>

<style></style>
